import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../../components/form-controls/Button";
import Switch from "../../../components/form-controls/Switch";
import Input from "../../../components/form-controls/Input";
import Select from 'react-select'
import TextArea from "../../../components/form-controls/TextArea";
import { ShortLinksService } from "../../../services/ShortLinksService";
import { AlertService } from "../../../services/Alert";
import { SubAccountService } from '../../../services/SubaccountService';
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import useModal from "../../../hooks/useModal";
import InvalidFeedback from "../../../components/InvalidFeedback";
import { useLocation } from "react-router-dom";
import { APPS } from "../../../constants";
import { useTranslation } from "react-i18next";
interface ModalCreateLinkProps {
    showModalLink: boolean;
    onRequestClose: (refresh: boolean) => void;
}
const CreateLinkModal = ({ showModalLink, onRequestClose }: ModalCreateLinkProps) => {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const { state: { channel } } = useLocation()

    const modalCreateLink = useRef<HTMLDivElement>(null);

    useModal(modalCreateLink, showModalLink)

    const [subAccounts, setsubAccounts] = useState([]);
    const opciones = [
        { label: 'Enviar a Subcuenta', value: 'sent_subaccount' },
        { label: 'Directo a agentes', value: 'sent_agent' },
        { label: 'Ninguno', value: 'none' }
    ];

    const defaultValues = {
        message: '',
        trigger: '',
        label: '',
        sub_account_id: 0,
        advanced_follow: false,
        app: channel.toUpperCase() === APPS.WHATSAPP_STANDAR ? 'waweb' : 'wa-business',
    }

    const { control, register, watch, setValue, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const advancedFollow = watch('advanced_follow');
    const subAccount = watch('sub_account_id');
    const trigger = watch('trigger');


    const getSubAccounts = async () => {
        const { data } = await SubAccountService.getSubaccounts(account.id);
        setsubAccounts(data.sub_accounts.map(subaccount => ({
            value: subaccount.id,
            label: subaccount.name
        })));
    };

    const submit = async (data) => {
        try {
            data.advanced_follow = data.advanced_follow ? 1 : 0;
            await ShortLinksService.save(account.id, data.message, data.app, data.trigger, data.label, data.sub_account_id, data.advanced_follow);
            await onRequestClose(true);
            AlertService.toastSuccess('Se guardó correctamente el enlace');
            reset(defaultValues);
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', error)
        }
    }

    useEffect(() => {
        getSubAccounts();
    }, []);

    useEffect(() => {
        if (!advancedFollow) {
            setValue('advanced_follow', false);
            setValue('label', defaultValues.label);
            setValue('sub_account_id', defaultValues.sub_account_id);
            setValue('trigger', defaultValues.trigger);
        }

    }, [advancedFollow, setValue]);

    useEffect(() => {
        if (!trigger) {
            setValue('trigger', '');
        }
    }, [trigger]);

    useEffect(() => {
        if (!subAccount) {
            setValue('sub_account_id', 0);
        }
    }, [subAccount]);


    return (
        <div className="modal fade" ref={modalCreateLink} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t("platform.channels.links-page.create-link")}</h4>
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Switch label="Seguimiento Avanzado" {...register('advanced_follow')} />
                            </div>

                            {advancedFollow && (
                                <>
                                    <div className="mb-3">
                                        <Input label='Etiqueta *' placeholder="Ingresa etiqueta" errors={errors.label} {...register('label', { required: true })} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Disparador *</label>
                                        <Controller
                                            control={control}
                                            name='trigger'
                                            rules={{ required: true }}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <>
                                                    <Select
                                                        options={opciones}
                                                        className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                                                        classNamePrefix='form-select-custom'
                                                        placeholder='Selecciona un disparador'
                                                        onChange={(selectedOption) => { onChange(selectedOption.value); }}
                                                        value={opciones.find(option => option.value === value) || null}
                                                    />
                                                    <InvalidFeedback error={error} />
                                                </>
                                            )}
                                        />
                                    </div>

                                    {trigger === 'sent_subaccount' && (
                                        <div className="mb-3">
                                            <label className="form-label">Subcuentas *</label>
                                            <Controller
                                                control={control}
                                                name='sub_account_id'
                                                rules={{ required: true }}
                                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                    <>
                                                        <Select
                                                            options={subAccounts}
                                                            className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                                                            classNamePrefix='form-select-custom'
                                                            placeholder='Selecciona una subcuenta'
                                                            onChange={(selectedOption) => onChange(selectedOption.value)}
                                                            value={subAccounts.find(option => option.value === value) || null}
                                                        />
                                                        <InvalidFeedback error={error} />
                                                    </>
                                                )}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                            <div className="mb-3">
                                <TextArea placeholder="Ingresa un mensaje" label={t("platform.channels.links-page.message-label")} errors={errors.message}  {...register('message', { required: true })} />
                                <p className="m-0 mt-3">{t("platform.channels.links-page.message-p")}</p>
                            </div>

                            {/* <div className="mb-3">
                                <label className="form-label" >Canal *</label>
                                <select className={'form-control ' + (errors?.app ? 'is-invalid' : '')}  {...register('app', { required: true })}>
                                    <option disabled value={''}>Elija una opción</option>
                                    <option value={'waweb'}>WhatsApp Estandar</option>
                                    <option value={'wa-business'}>WhatsApp Business</option>
                                </select>
                                <InvalidFeedback error={errors.app} />
                            </div> */}

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreateLinkModal
